var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',_vm._g(_vm._b({class:{ waiting: _vm.waiting }},'base-button',_vm.button_props,false),_vm.$listeners),[(_vm.waiting)?_c('loader',{attrs:{"size":"sm"}}):_vm._e(),_c('span',{class:{ 'd-invisible': _vm.waiting }},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }